import { z } from 'zod';
export const CAPAS_CALENDARIO = [
    'TODOS',
    'DINERO',
    'OPERACIONES',
    'COBROS',
    'PAGOS',
    'HITOS',
    'LICITACIONES',
];
export const capaCalendarioSchema = z.enum(CAPAS_CALENDARIO);
export const filtrosCalendarioSchema = z.object({
    desde: z.string().optional(),
    hasta: z.string().optional(),
    mes: z.string().regex(/^\d{4}-\d{2}$/, 'El mes debe tener formato YYYY-MM').optional(),
    capa: capaCalendarioSchema.default('TODOS'),
});
export const perspectivaMultimesSchema = z.object({
    mesReferencia: z.string().regex(/^\d{4}-\d{2}$/, 'El mes debe tener formato YYYY-MM').optional(),
    cantidadMeses: z.coerce.number().int().min(1).max(12).default(3),
    capa: capaCalendarioSchema.default('TODOS'),
});
//# sourceMappingURL=calendario.js.map